import { MonitorUp, MonitorX } from "lucide-react";
import { Button } from "@themes/pollinator/ui/Button";
import { ContainerBreakpoints } from "../../videoMeeting.types";
import { useBrowserCompatibilityFeatures } from "@platform/features/video/hooks/useBrowserCompatibilityFeatures";

export type Props = {
  label?: string;
  isLocalUserSharing: boolean;
  isLoading: boolean;
  onToggleContentShare: () => void;
  onTogglePauseContentShare: () => void;
  containerBreakpoints: ContainerBreakpoints;
};

export function VideoMeetingControlsContentShare({
  label = "Share Screen",
  isLocalUserSharing,
  isLoading,
  onToggleContentShare,
  onTogglePauseContentShare,
  containerBreakpoints,
  ...rest
}: Props) {
  // Get browser compatibility features
  const { supportsScreenShare } = useBrowserCompatibilityFeatures();

  return (
    <>
      <Button
        iconComponent={isLocalUserSharing ? MonitorX : MonitorUp}
        onClick={supportsScreenShare ? onToggleContentShare : () => {}}
        destructive={isLocalUserSharing}
        disabled={!supportsScreenShare}
        isLoading={isLoading}
        variant="ghost"
        theme="dark"
        {...rest}
      >
        {containerBreakpoints && containerBreakpoints.isMd
          ? isLocalUserSharing
            ? "Stop Sharing"
            : label
          : ""}
      </Button>
    </>
  );
}

export default VideoMeetingControlsContentShare;
